import { useEffect, useState } from 'react'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation19({ animation, badge, all_animations }: Props) {
  const [showBadge, setShowBadge] = useState(false)
  const [visibleChars, setVisibleChars] = useState<number[]>([])

  const text = `BADGE DÉBLOQUÉ`
  const chars = text.split('')

  useEffect(() => {
    setTimeout(() => setShowBadge(true), 500)

    chars.forEach((_, index) => {
      setTimeout(() => {
        setVisibleChars(prev => [...prev, index])
      }, 100 + index * 80)
    })
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes bounceIn {
          0% {
            transform: translateY(-100px) scale(0);
            opacity: 0;
          }
          40% {
            transform: translateY(20px) scale(1.2);
            opacity: 1;
          }
          60% {
            transform: translateY(-10px) scale(0.9);
          }
          80% {
            transform: translateY(5px) scale(1.05);
          }
          100% {
            transform: translateY(0) scale(1);
          }
        }
        @keyframes continuousBounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .bounce-in {
          animation: bounceIn 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }
        .continuous-bounce {
          animation: continuousBounce 1s ease-in-out infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        {/* Texte rebondissant */}
        <div className="flex flex-wrap justify-center gap-1 mb-8">
          {chars.map((char, index) => (
            <span
              key={index}
              className={`text-2xl sm:text-4xl font-black text-tessan-yellow ${
                visibleChars.includes(index) ? 'bounce-in' : 'opacity-0'
              } ${
                visibleChars.length === chars.length ? 'continuous-bounce' : ''
              }`}
              style={{
                animationDelay: visibleChars.length === chars.length ? `${index * 0.08}s` : '0s'
              }}
            >
              {char === ' ' ? '\u00A0' : char}
            </span>
          ))}
        </div>

        {/* Badge */}
        <div className={`transition-all duration-700 ${showBadge ? 'scale-100 opacity-100' : 'scale-0 opacity-0'}`}>
          <div className="w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50">
            <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
          </div>
        </div>

        <div className={`mt-8 text-center transition-all duration-500 delay-700 ${showBadge ? 'opacity-100' : 'opacity-0'}`}>
          <div className="text-2xl sm:text-4xl font-black text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
